import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { EQuoteItemStatusCode, EQuoteType, IQuoteApiResponse } from 'types/quote.types';
import { QuoteService } from 'services/quote.service';
import { successPromiseWithData } from 'utils/simulationPromise';
import QuoteDetailDevices from '../QuoteDetailDevices/QuoteDetailDevices';
import QuoteDetailHeader from '../QuoteDetailHeader/QuoteDetailHeader';
import QuoteDetailSummary from '../QuoteDetailSummary/QuoteDetailSummary';
import QuoteDetailNotice from '../QuoteDetailNotice/QuoteDetailNotice';
import QuoteDetailExploratoryLayout from '../QuoteDetailExploratoryLayout/QuoteDetailExploratoryLayout';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

import './QuoteDetailsModule.scss';

/**
 * Módulo principal del detalle de cotización. Orquesta el estado compartido entre subcomponentes.
 */
const QuoteDetailsModule = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [quoteDetailsInfo, setQuoteDetailsInfo] = useState<IQuoteApiResponse | undefined>();
  const [quoteDetailsInfoFake, setQuoteDetailsInfoFake] = useState<typeof mockData | undefined>();
  const [lastItemStatusChange, setLastItemStatusChange] = useState<string | undefined>();

  const mockData = {
    history: {
      cancelled: [],
      expired: [
        { type: 'tipo de historial expired 1', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial expired 2', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial expired 3', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' }
      ],
      approved: [
        {
          type: 'tipo de historial approved 1',
          date: '00/00/0000 - 00:00 PM',
          description: 'esta es uina descripcion'
        },
        {
          type: 'tipo de historial approved 2',
          date: '00/00/0000 - 00:00 PM',
          description: 'esta es uina descripcion'
        },
        { type: 'tipo de historial approved 3', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' }
      ],
      pendingApproval: [
        { type: 'tipo de historial pending 1', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial pending 2', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial pending 3', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' }
      ],
      toQuote: [
        { type: 'tipo de historial toQuote 1', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial toQuote 2', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' },
        { type: 'tipo de historial toQuote 3', date: '00/00/0000 - 00:00 PM', description: 'esta es uina descripcion' }
      ]
    },
    items: [
      {
        quoteItemId: 3421,
        productId: 1,
        productName: 'Lenovo ThinkPad X1 Carbon ahsdghagsdhj agsdhjg jshdjahsdj khasdjk  ',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'i7', Almacenamiento: '1TB SSD', Memoria: '16GB' },
        categoryName: 'Laptops',
        quantity: 20,
        quoteStatus: { id: 1, uuid: 'uuid-qs-1', code: EQuoteItemStatusCode.PENDING_QUOTE },
        suggestedItems: [
          {
            id: 1,
            name: 'Ingram',
            availableStock: 20,
            cost: '$2.000 USD',
            salePrice: '$2.500 USD',
            deliveryEstimate: '12/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-3421-1', code: EQuoteItemStatusCode.QUOTED }
          }
        ]
      },
      {
        quoteItemId: 8754,
        productId: 2,
        productName: 'Dell XPS 13',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'i5', Almacenamiento: '512GB SSD', Memoria: '8GB' },
        categoryName: 'Laptops',
        quantity: 10,
        quoteStatus: { id: 2, uuid: 'uuid-qs-2', code: EQuoteItemStatusCode.QUOTING }
      },
      {
        quoteItemId: 1293,
        productId: 3,
        productName: 'Apple MacBook Pro 14"',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'M3', Almacenamiento: '512GB', Memoria: '16GB' },
        categoryName: 'Laptops',
        quantity: 5,
        procurementReason: 'ya no habia de otras',
        quoteStatus: { id: 3, uuid: 'uuid-qs-3', code: EQuoteItemStatusCode.QUOTED },
        suggestedItems: [
          {
            id: 1,
            name: 'iShop',
            availableStock: 8,
            cost: '$3.200 USD',
            salePrice: '$3.800 USD',
            deliveryEstimate: '20/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-1293-1', code: EQuoteItemStatusCode.APPROVED }
          }
        ]
      },
      {
        quoteItemId: 6607,
        productId: 4,
        productName: 'Laptop',
        pills: { Procesador: 'i7', Almacenamiento: '512GB SSD', Memoria: '16GB' },
        categoryName: 'Laptops',
        quantity: 8,
        isGenericProduct: true,
        quoteStatus: { id: 4, uuid: 'uuid-qs-4', code: EQuoteItemStatusCode.PENDING_APPROVAL },
        suggestedItems: [
          {
            id: 1,
            name: 'Ingram',
            availableStock: 10,
            cost: '$1.800 USD',
            salePrice: '$2.200 USD',
            deliveryEstimate: '18/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-6607-1', code: EQuoteItemStatusCode.PENDING_APPROVAL }
          }
        ]
      },
      {
        quoteItemId: 9182,
        productId: 5,
        productName: 'Microsoft Surface Pro 9',
        imageUrl: '',
        pills: { Procesador: 'i5', Almacenamiento: '256GB', Memoria: '8GB' },
        categoryName: 'Tablets',
        quantity: 15,
        isGenericProduct: true,
        quoteStatus: { id: 5, uuid: 'uuid-qs-5', code: EQuoteItemStatusCode.APPROVED },
        suggestedItems: [
          {
            id: 1,
            name: 'CDW',
            availableStock: 20,
            cost: '$1.200 USD',
            salePrice: '$1.500 USD',
            deliveryEstimate: '22/04/2026',
            producName: 'Nombre de muestra',
            sku: '12345678',
            quoteStatus: { id: 1, uuid: 'uuid-ps-9182-1', code: EQuoteItemStatusCode.APPROVED }
          },
          {
            id: 2,
            name: 'Ingram',
            availableStock: 15,
            cost: '$1.100 USD',
            salePrice: '$1.400 USD',
            deliveryEstimate: '25/04/2026',
            quoteStatus: { id: 2, uuid: 'uuid-ps-9182-2', code: EQuoteItemStatusCode.QUOTED }
          }
        ]
      },
      {
        quoteItemId: 4455,
        productId: 6,
        productName: 'ASUS ZenBook 14',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'Ryzen 7', Almacenamiento: '1TB SSD', Memoria: '16GB' },
        categoryName: 'Laptops',
        quantity: 12,
        quoteStatus: { id: 6, uuid: 'uuid-qs-6', code: EQuoteItemStatusCode.PURCHASED },
        suggestedItems: [
          {
            id: 1,
            name: 'Ingram',
            availableStock: 15,
            cost: '$1.100 USD',
            salePrice: '$1.400 USD',
            deliveryEstimate: '25/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-4455-1', code: EQuoteItemStatusCode.PURCHASED }
          }
        ]
      },
      {
        quoteItemId: 2038,
        productId: 7,
        productName: 'Samsung Galaxy Tab S9',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'Snapdragon', Almacenamiento: '256GB', Memoria: '12GB' },
        categoryName: 'Tablets',
        quantity: 6,
        quoteStatus: { id: 7, uuid: 'uuid-qs-7', code: EQuoteItemStatusCode.REJECTED },
        suggestedItems: [
          {
            id: 1,
            name: 'Samsung Direct',
            availableStock: 10,
            cost: '$800 USD',
            salePrice: '$950 USD',
            deliveryEstimate: '28/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-2038-1', code: EQuoteItemStatusCode.REJECTED }
          }
        ]
      },
      {
        quoteItemId: 7716,
        productId: 8,
        productName: 'Logitech MX Keys',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Conectividad: 'Bluetooth', Puerto: 'USB-C' },
        categoryName: 'Periféricos',
        quantity: 30,
        quoteStatus: { id: 8, uuid: 'uuid-qs-8', code: EQuoteItemStatusCode.UNAVAILABLE },
        suggestedItems: [
          {
            id: 1,
            name: 'Ingram',
            availableStock: 50,
            cost: '$120 USD',
            salePrice: '$150 USD',
            deliveryEstimate: '10/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-7716-1', code: EQuoteItemStatusCode.UNAVAILABLE }
          }
        ]
      },
      {
        quoteItemId: 5341,
        productId: 9,
        productName: 'Dell UltraSharp 27"',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Resolución: '4K', Puerto: 'USB-C', Panel: 'IPS' },
        categoryName: 'Monitores',
        quantity: 10,
        quoteStatus: { id: 9, uuid: 'uuid-qs-9', code: EQuoteItemStatusCode.EXPIRED },
        suggestedItems: [
          {
            id: 1,
            name: 'Dell Direct',
            availableStock: 12,
            cost: '$700 USD',
            salePrice: '$850 USD',
            deliveryEstimate: '30/04/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-5341-1', code: EQuoteItemStatusCode.EXPIRED }
          }
        ]
      },
      {
        quoteItemId: 8823,
        productId: 10,
        productName: 'Apple Magic Mouse',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        pills: { Conectividad: 'Bluetooth', Puerto: 'USB-C' },
        categoryName: 'Periféricos',
        quantity: 25,
        quoteStatus: { id: 1, uuid: 'uuid-qs-1', code: EQuoteItemStatusCode.PENDING_QUOTE },
        suggestedItems: [
          {
            id: 1,
            name: 'iShop',
            availableStock: 30,
            cost: '$80 USD',
            salePrice: '$100 USD',
            deliveryEstimate: '05/05/2026',
            quoteStatus: { id: 1, uuid: 'uuid-ps-8823-1', code: EQuoteItemStatusCode.PENDING_QUOTE }
          }
        ]
      },
      {
        quoteItemId: 9901,
        productId: 11,
        productName: 'Lenovo ThinkPad X1 Carbon Gen 11',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'i7', Almacenamiento: '1TB SSD', Memoria: '32GB' },
        categoryName: 'Laptops',
        quantity: 8,
        quoteStatus: { id: 3, uuid: 'uuid-qs-11', code: EQuoteItemStatusCode.QUOTED },
        suggestedItems: [
          {
            id: 1,
            name: 'Ingram',
            availableStock: 10,
            cost: '$2.100 USD',
            salePrice: '$2.600 USD',
            deliveryEstimate: '15/05/2026',
            producName: 'ThinkPad X1 Carbon Gen 11 21HM',
            sku: 'LN-X1C-0071',
            quoteStatus: { id: 1, uuid: 'uuid-ps-1', code: EQuoteItemStatusCode.APPROVED }
          }
        ]
      },
      {
        quoteItemId: 9902,
        productId: 12,
        productName: 'HP EliteBook 840 G10',
        imageUrl:
          'https://p1-ofp.static.pub/ShareResource/na/series/think/products/lenovo-thinksystem-p520-isv-certifications.png',
        brandImage:
          'https://d3jfrqiwvd5im4.cloudfront.net/images/brandinglenovo-logolenovologoposredlowres-CLRuzpnT_-regular.png',
        pills: { Procesador: 'i5', Almacenamiento: '512GB SSD', Memoria: '16GB' },
        categoryName: 'Laptops',
        quantity: 4,
        quoteStatus: { id: 3, uuid: 'uuid-qs-12', code: EQuoteItemStatusCode.QUOTED },
        suggestedItems: [
          {
            id: 1,
            name: 'CDW',
            availableStock: 6,
            cost: '$1.800 USD',
            salePrice: '$2.200 USD',
            deliveryEstimate: '18/05/2026',
            producName: 'HP EliteBook 840 G10 Wolf Pro Security',
            sku: 'HP-EB840-0087',
            quoteStatus: { id: 2, uuid: 'uuid-ps-2', code: EQuoteItemStatusCode.REJECTED }
          }
        ]
      }
    ]
  };
  /** Retorna la fecha más reciente de cambio de estado entre todos los items. */
  const getLastItemStatusChange = (items: IQuoteApiResponse['items']) =>
    items
      ?.map(item => item.lastStatusChange)
      .filter(Boolean)
      .sort()
      .at(-1);

  /** Simula la carga del detalle de cotización desde la API */
  const fetchQuoteDetails = async () => {
    try {
      const dataQuoteDetails = await QuoteService.getQuoteDetails(Number(id));
      setQuoteDetailsInfo(dataQuoteDetails);
      setLastItemStatusChange(getLastItemStatusChange(dataQuoteDetails?.items));
      const { resolveData } = await successPromiseWithData({ time: 100, resolveData: mockData });
      setQuoteDetailsInfoFake(resolveData);
    } catch {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchQuoteDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (quoteDetailsInfo?.quoteType?.code === EQuoteType.EXPLORATORY) {
    return (
      <QuoteDetailExploratoryLayout
        quote={quoteDetailsInfo}
        isLoading={isLoading}
        onRefresh={fetchQuoteDetails}
        history={quoteDetailsInfoFake?.history}
        lastItemStatusChange={lastItemStatusChange}
        onCancelSuccess={fetchQuoteDetails}
      />
    );
  }

  return (
    <div className="quoteDetailsModule">
      <div className="quoteDetailsModuleContent">
        <QuoteDetailHeader
          isLoading={isLoading}
          {...quoteDetailsInfoFake}
          id={quoteDetailsInfo?.id}
          responsibles={quoteDetailsInfo?.responsibles}
          onResponsiblesUpdate={fetchQuoteDetails}
          requestedByUser={quoteDetailsInfo?.requestedByUser}
          requestedCountry={quoteDetailsInfo?.requestedCountry}
          createdAt={quoteDetailsInfo?.createdAt}
          organizationName={quoteDetailsInfo?.organizationName}
          organizationId={quoteDetailsInfo?.organizationId}
          parentQuoteId={quoteDetailsInfo?.parentQuoteId}
          lastItemStatusChange={lastItemStatusChange}
          quoteStatus={quoteDetailsInfo?.quoteStatus}
          onCancelSuccess={fetchQuoteDetails}
          referenceCode={quoteDetailsInfo?.referenceCode}
        />
        <QuoteDetailNotice
          isLoading={isLoading}
          slas={quoteDetailsInfo?.slas}
          slaElapsedHours={quoteDetailsInfo?.slaElapsedHours}
          quoteStatusCode={quoteDetailsInfo?.quoteStatus?.code}
          items={quoteDetailsInfo?.items}
        />
        <div className="devicesAndSummary">
          <QuoteDetailDevices
            items={quoteDetailsInfo?.items}
            isLoading={isLoading}
            quoteStatusCode={quoteDetailsInfo?.quoteStatus?.code}
            quoteId={quoteDetailsInfo?.id}
          />

          <QuoteDetailSummary
            isLoading={isLoading}
            summary={quoteDetailsInfo?.summary}
            quoteId={quoteDetailsInfo?.id}
            clientName={quoteDetailsInfo?.organizationName}
            countryName={quoteDetailsInfo?.requestedCountry?.name}
            countryCode={quoteDetailsInfo?.requestedCountry?.code}
            organizationId={quoteDetailsInfo?.organizationId}
            onSendSuccess={fetchQuoteDetails}
            slas={quoteDetailsInfo?.slas}
            quoteStatusCode={quoteDetailsInfo?.quoteStatus?.code}
            items={quoteDetailsInfo?.items ?? []}
            parentQuoteId={quoteDetailsInfo?.parentQuoteId}
          />
        </div>
      </div>
    </div>
  );
};

export default QuoteDetailsModule;
